module.exports = __webpack_public_path__ + "static/media/epic_booster.c3d9cc81.webp";